module.exports = __webpack_public_path__ + "static/media/django.10929960.jpg";